import React, { useEffect, useState } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import NotesTable from "../../../components/tables/notesTable";
import PagePagination from "../../../components/tables/pagination";
import Repository from "../../../configs/axios/repository";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handlePlanState } from "../../../redux/layout";
const Home = (props) => {
    localStorage.setItem("canDoIt", true);
    const dispatch = useDispatch();
    const [loadingData, setLoadingData] = useState(false);
    const [notes, setNotes] = useState([]);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);
    const [createdMonthCount, setCreatedMonthCount] = useState(0);
    const [isUserStripeSubscription, setIsUserStripeSubscription] =
        useState(false);
    const [count, setCount] = useState();
    const history = useHistory();
    let canDoIt = true;
    const role = useSelector((state) => state.layout.role);

    const createNote = async (values) => {
        history.push({
            pathname: "/createNote",
        });
    };

    const findNotes = async (skipTake) => {
        const result = await Repository.postRequest(
            `api/notes/findNotesByUserId`,
            skipTake
        );
        if (result.data?.success) {
            setCreatedMonthCount(result.data.data.createdMonthCount);

            setCount(result.data.data.count);
            setNotes(result.data.data.notes);

            dispatch(handlePlanState(result.data.data.subscriptionType));
            if (
                result.data.data.stripeSubscriptionType == "active" ||
                result.data.data.stripeSubscriptionType == "trialing"
            ) {
                setIsUserStripeSubscription(true);
            } else {
                setIsUserStripeSubscription(false);
            }

            setLoadingData(true);
        }

        setLoadingData(true);
    };

    const refreshTable = () => {
        let skipTake = {
            skip: skipData,
            take: showData,
        };
        findNotes(skipTake);
    };

    useEffect(() => {
        refreshTable();
    }, [showData, skipData, role]);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className="d-flex justify-content-between mb-2 px-2">
                <div className="clidrenDivCompakt testH1">
                    <div id="yourNotes" className="mt-3 ">
                        <h1>Your Notes</h1>
                    </div>
                </div>

                {createdMonthCount >= 3 && !isUserStripeSubscription ? (
                    <div
                        className="createBtnDiv testButton"
                        onMouseOver={(e) => {
                            e.target.innerText = "7 Day Free Trial";
                        }}
                        onMouseOut={(e) => {
                            e.target.innerText = "NEW NOTE";
                        }}
                        onClick={() => {
                            history.push({
                                pathname: "/subscription",
                            });
                        }}
                    >
                        <span className="plus">+</span>
                        <span>NEW NOTE </span>
                    </div>
                ) : (
                    <div
                        className="createBtnDiv"
                        onClick={() => {
                            createNote(false);
                        }}
                    >
                        <span className="plus">+</span>
                        <span>NEW NOTE </span>
                    </div>
                )}
            </div>
            {notes.length > 0 ? (
                <div>
                    <NotesTable
                        notes={notes}
                        refreshTable={refreshTable}
                        setLoadingData={setLoadingData}
                        loadingData={loadingData}
                        canDoIt={canDoIt}
                    />

                    <PagePagination
                        setShow={setShowData}
                        count={count}
                        setSkip={setSkipData}
                        skip={skipData}
                        show={showData}
                    />
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}
        </div>
    ) : (
        <div className="spinerHome">
            <Spinner spiner={true} />
        </div>
    );
};

export default Home;
